import React from 'react'
import PackingConverterFormPageContainer from './PackingConverterFormPageContainer'

export class PackingConverterFormPage extends React.Component{
    render(){
        return(
            <PackingConverterFormPageContainer {...this.props} />
        )
    }
}